import { ItemHeader } from '@/components/Style/Common'

export interface Props {
  header: string
  value: string
}

const SectionDetail = ({ header, value }: Props) => {
  return (
    <div>
      <ItemHeader>{header}</ItemHeader>
      <p>{value}</p>
    </div>
  )
}

export default SectionDetail
